module.exports = __webpack_public_path__ + "static/9heartwarminggames1-99ebaa05ceed2559df2522fcb4424188.webp";